import createMockSource from 'utils/createMockSource';

// Battery rich fields (status, cycle life, cycles, last synced, used-with) have no API source yet.
// One variant per card, assigned by index in useData, so the grid looks realistic. Logs on render.
export const batteryMocks = createMockSource('batteryCard', {
    variants: [
        {
            cyclesTotal: 300,
            cyclesUsed: 84,
            dronesUsedWith: ['Drone 01', 'Drone 02'],
            isSyncStale: false,
            lastSynced: '2m ago'
        },
        {
            cyclesTotal: 300,
            cyclesUsed: 142,
            dronesUsedWith: ['Drone 01', 'Drone 03'],
            isSyncStale: false,
            lastSynced: '3h ago'
        },
        {
            cyclesTotal: 300,
            cyclesUsed: 271,
            dronesUsedWith: ['Drone 03', 'Drone 05'],
            isSyncStale: false,
            lastSynced: '1h ago'
        },
        {
            cyclesTotal: 300,
            cyclesUsed: 198,
            dronesUsedWith: ['Drone 02', 'Drone 04'],
            isSyncStale: true,
            lastSynced: '2d ago'
        },
        {
            cyclesTotal: 300,
            cyclesUsed: 256,
            dronesUsedWith: ['Drone 04', 'Drone 05'],
            isSyncStale: false,
            lastSynced: '1h ago'
        }
    ]
});
